import styled from '@emotion/styled';
import { TextStyle } from 'styles/variables/mixins';
import { Variables } from 'styles/variables/variables';
import { Link as LinkComponent } from 'react-router-dom';
import { ReactComponent as InfoIconIcon } from 'assets/icons/information.svg';
import { Colors } from 'styles/variables/colors';
import { ReactComponent as CrossSimpleIcon } from 'assets/icons/cross-simple.svg';
import { ReactComponent as Hourglass } from 'assets/icons/hourglass.svg';
import { ReactComponent as WarningMarkIcon } from 'assets/icons/warning_mark.svg';
import { ReactComponent as CheckMark } from 'assets/icons/check_mark.svg';
import { ReactComponent as ArrowDown } from 'assets/icons/arrow-down.svg';

export const ArrowDownIcon = styled(ArrowDown)`
    path {
        fill: ${Colors.darkGray};
    }
    width: 9px;
    height: 9px;
    cursor: pointer;
    margin-top: 2px;
`;

export const XIcon = styled(CrossSimpleIcon)`
    path {
        fill: ${Colors.white};
    }
    width: 9px;
    height: 9px;
`;

export const HourglassIcon = styled(Hourglass)`
    path {
        fill: ${Colors.white};
    }
    width: 9px;
    height: 12px;
`;

export const WarningIcon = styled(WarningMarkIcon)`
    path {
        fill: ${Colors.white};
    }
    width: 13px;
    height: 13px;
`;

export const CheckmarkIcon = styled(CheckMark)`
    path {
        fill: ${Colors.white};
    }
    width: 13px;
    height: 13px;
`;

export enum StatusColor {
    gray = 'rgb(50, 56, 66)',
    red = 'rgb(242, 33, 40)',
    brown = 'rgb(148, 62, 0)',
    orange = 'rgb(239, 152, 52)',
    purple = 'rgb(131, 83, 226)',
    blue = 'rgba(74, 82, 187)',
    green = 'rgb(17, 123, 52)',
}

export const Button = styled.button`
    display: flex;
    color: ${Colors.darkGray};
    fill: ${Colors.darkGray};

    :hover {
        opacity: 0.8;
    }
    :disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
`;

export const SendInvitationBtn = styled.button`
    height: 36px;
    width: 130px;
    ${TextStyle({ fontSize: '14px', fontWeight: '400', color: `${Colors.salesNextBtn}` })}
    background: white; /* white */
    opacity: 1;
    border: 1px solid ${Colors.salesNextBtn}; /* border-s */
    border-radius: 3px;

    :hover {
        color: #ffffffff; /* white */
        background: ${Colors.salesNextBtnHover}; /* secondary-600 */
    }
`;

export const CurrencyButton = styled.button<{ paid: boolean }>`
    vertical-align: middle;
    path {
        fill: ${({ paid }) => (paid ? 'rgb(17, 123, 52)' : '#CCCCCC')};
    }

    :hover {
        path {
            fill: ${({ paid }) => (paid ? '#CCCCCC' : 'rgb(17, 123, 52)')};
        }
    }
`;

export const ButtonWrapper = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
`;

export const FakeLink = styled.div`
    color: ${Colors.blue};
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    /* width: 100%; */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
`;

export const FileStatus = styled.span`
    background: gray;
    border-radius: 4px;
    padding: 1px 5px 1px 5px;
    display: initial;
    text-overflow: ellipsis;
`;

export const Link = styled(LinkComponent)`
    color: ${Colors.blue};
    text-decoration: underline;
`;

export const ListTable = styled.div`
    ${TextStyle({
        fontSize: '16px',
        fontWeight: '400',
        color: '#282828',
        fontFamily: Variables.assistant,
    })};
    line-height: 20px;
    padding: 0 30px 30px 30px;
    border-radius: 4px;
    border: 1px solid ${Colors.tableBorder};
    box-shadow: 0px 10px 20px -15px #171a1f;
    overflow-y: auto;
    /* max-height: 560px; */
    max-height: calc(100vh - 250px);
    width: 100%;
    overflow-x: auto;

    & > div > div {
        border-bottom: 1px solid #f5f5f5;
    }

    & > div:last-child div,
    & > div:first-child div {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        padding: 0px;
    }
`;

export const Modal = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    max-height: 100%;
    background: ${Colors.white};
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
    border-radius: 4px;

    :focus-visible {
        outline: none;
    }
`;

export const ModalWrapper = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    max-height: 80%;
    height: 100%;
    width: 100%;
    max-width: 932px;
    overflow: hidden;
`;

export const Status = styled.span<{ color: string }>`
    padding: 1px 9px 1px 9px;
    border-radius: 15px;
    line-height: 1;
    font-weight: 500;
    text-align: center;
    background: ${({ color }) =>
        color === StatusColor.gray
            ? 'rgb(50, 56, 66, 0.2)'
            : color === StatusColor.red
              ? 'rgb(242, 33, 40, 0.2)'
              : color === StatusColor.brown
                ? 'rgb(148, 62, 0, 0.2)'
                : color === StatusColor.orange
                  ? 'rgb(239, 152, 52, 0.2)'
                  : color === StatusColor.purple
                    ? 'rgb(131, 83, 226, 0.2)'
                    : color === StatusColor.blue
                      ? 'rgba(74, 82, 187, 0.2)'
                      : color === StatusColor.green
                        ? 'rgb(17, 123, 52, 0.2)'
                        : '#FEF8F1FF'};
    color: ${({ color }) => color};
`;

export const NewStatus = styled.span<{ color: string }>`
    padding: 2px 5px 2px 5px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    gap: 6px;
    font-weight: 500;
    text-align: center;
    background: ${({ color }) => color};
    color: ${Colors.white};
    font-family: ${Variables.montserrat};
    font-size: 13px;
    width: fit-content;
`;

export const SpanForMobile = styled.span`
    display: none;

    @media (max-width: 768px) {
        display: flex;
    }
`;

export const GreyOnHover = styled.div`
    :hover {
        background-color: ${Colors.lightGrayBorder};
    }
`;
export const ITAStatusWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
`;
export const ITAStatusIndicator = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: red;
`;

export const InfoIcon = styled(InfoIconIcon)<{ open: boolean }>`
    width: 17.5px;
    height: 18.39px;
    path {
        fill: ${({ open }) => (open ? Colors.gray : Colors.lightGray)};
    }
`;

export const InfoIconRow = styled.div<{ mobile: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${({ mobile }) => (mobile ? '6px' : '16px')};
`;

export const StatusContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    margin-left: 3px;
`;

export const StatusDot = styled.div<{ color: string }>`
    width: 8px;
    height: 8px;
    background: ${({ color }) => color};
    border-radius: 50%;
`;

export const StatusText = styled.span`
    font-family: ${Variables.montserrat};
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    color: ${Colors.darkGray};
`;
